module.exports = __webpack_public_path__ + "img/services-project-icon.a57f33c4.svg";